<template>
  <div class="TopFilter top-filter-02 safe-area_width_2">
    <div class="type-filter" v-if="publicResource.typesId">
      <span>筛选类型：</span>
      <a
        v-for="item in typeFilter2"
        :key="item.text"
        :href="`/gjxx/${wId}_${areaId}_${item.id}`"
        class="mr--10 hover-text_theme"
        :class="{ 'theme-color': item.id == typeId }"
        >{{ item.text }}</a
      >
    </div>

    <div class="f-layout mt--20">
      <span class="select-area-text">选择地区：</span>
      <div>
        <p class="ml--10">
          <a :class="{ 'theme-color': areaId === 2703 || !areaId }" :href="getCompleteHref('2703')">全国</a>
        </p>
        <p>
          <a
            v-for="item in areasFilter2"
            :key="item.areaId"
            :href="getCompleteHref(item.areaId)"
            class="mr--10 ml--10 mt--10 a-link hover-text_theme"
            :class="{ 'theme-color': item.areaId == Number(areaId) + '' }"
            :title="`${item.text}${keyword}招标信息-千里马招标网`"
            >{{ item.text }}</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { imgPath } from "@/utils/constants/constants";
import { typeFilter2, areasFilter2 } from "@/utils/constants/gjxx_data_moudle";

export default {
  name: "TopFilter",
  props: ["areaId"],
  components: {},
  data() {
    return {
      username: "",
      imgPath,
      pageType: "gjxx",
      inputVal: "",
      typeId: "",
      wId: "",
      typeFilter2,
      areasFilter2,
      keyword: "",
    };
  },
  computed: {
    publicResource() {
      return this.$store.getters["gjxx/otherObj"];
    },
  },
  watch: {
    publicResource: {
      handler(val) {
        this.typeId = val.typesId;
        this.wId = val.wId;
        this.keyword = val.keyword;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    getCompleteHref(val) {
      const typeStr = this.typeId ? "_" + this.typeId : "";

      let href = "";
      switch (this.pageType) {
        case "hot":
          href = `/hot${this.wId}${val}/`;
          break;
        case "gjxx":
          href = `/gjxx/${this.wId}_${val}${typeStr}`;
          break;
      }
      return href;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variable.scss";
.TopFilter {
  &.top-filter-02 {
    border: 1px solid #e5e5e5;
    padding: 20px;
    font-size: 14px;
  }

  .select-area-text {
    width: 104px;
  }

  .a-link {
    display: inline-block;
  }
}
</style>
